import { Button, Flex, Heading } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const Unauthorized = () => {
    const navigate = useNavigate()
  return (
    <Flex 
    width="100wh"
    height="100vh"
    backgroundColor="#f5f5f5"
    justifyContent="center"
    alignItems="center"
    flexDirection={'column'}>
       <Heading color={'red.700'} mb={2}>
            Unauthorized
        </Heading>
        <Flex>
          <Button size={'sm'} colorScheme={'linkedin'} onClick={() => navigate(-3)}>Go back</Button>
          <Button size={'sm'} ml={2} colorScheme={'red'} onClick={() => {
            localStorage.removeItem('token')
            sessionStorage.clear()
            navigate('/')
          }}>Log out</Button>
        </Flex>
    </Flex>
  )
}

export default Unauthorized